import { useContext, useEffect, useState } from 'react';
import { LanguageContext } from '../Components/LanguageContext';
import Layout from '../Layout';
import NavLang from '../lang/pages/nav.json'
import AnimatedComponent from '../Components/AnimatedComponent'
import Background from '../public/images/bg_main.svg';
import MobileHeroDiagonal from '../Components/MobileHeroDiagonal';
import NavigationBar from '../Components/NavigationBar';
import Brands from '../Components/Brands';
import ProductRange from '../Components/ProductRange';
import handleTransformLang from '../functions/handleTransformLang'
import DealershipActionCards from '../Components/DealershipActionCards';

import LangData from '../lang/pages/home.json'
import homePageData from '../lang/homePage/homePage.json'
import orangeBannerData from '../lang/homePage/orangeBanner.json'
import blueBannerData from '../lang/homePage/blueBanner.json'
import whyBulutmarketData from '../lang/homePage/whyBulutmarket.json'
import Carousel from '../Components/Carousel';

export default function Home() {
    return (
        <Layout headData={LangData.head}>
            <InnerPage />
        </Layout>
    )
}

function InnerPage() {

    const { language } = useContext(LanguageContext);
    const [main, setMain] = useState(LangData.main);
    const [content, setContent] = useState(handleTransformLang(NavLang));
    const [orangeBannerItems, setOrangeBannerItems] = useState(getIterableData(orangeBannerData));
    const [blueBannerItems, setBlueBannerItems] = useState(getIterableData(blueBannerData));
    const [whyBulutmarketItems, setWhyBulutmarketItems] = useState(getIterableData(whyBulutmarketData));
    const [section2, setSection2] = useState(handleTransformLang(homePageData.section2))
    const [section3, setSection3] = useState(handleTransformLang(homePageData.section3))
    const [section4, setSection4] = useState(handleTransformLang(homePageData.section4))
    const [blueBannerIndex, setBlueBannerIndex] = useState(0)
    const [orangeBannerIndex, setOrangeBannerIndex] = useState(0)

    function getIterableData(data) {
        return Object.values(data).map(
            (product) => handleTransformLang(product)
        )
    }

    useEffect(() => {
        setMain(LangData.main)
        setContent(handleTransformLang(NavLang))
        setOrangeBannerItems(getIterableData(orangeBannerData))
        setBlueBannerItems(getIterableData(blueBannerData))
        setWhyBulutmarketItems(getIterableData(whyBulutmarketData))
        setSection2(handleTransformLang(homePageData.section2))
        setSection3(handleTransformLang(homePageData.section3))
        setSection4(handleTransformLang(homePageData.section4))
        setBlueBannerIndex(0)
        setOrangeBannerIndex(0)
    }, [language])

    const compactBlueBannerItems = blueBannerItems.slice(0, 2)
    const currentBlueBannerItem = compactBlueBannerItems[blueBannerIndex] || compactBlueBannerItems[0]
    const currentOrangeBannerItem = orangeBannerItems[orangeBannerIndex] || orangeBannerItems[0]

    function showPreviousBlueBanner() {
        setBlueBannerIndex((current) => (current === 0 ? compactBlueBannerItems.length - 1 : current - 1))
    }

    function showNextBlueBanner() {
        setBlueBannerIndex((current) => (current === compactBlueBannerItems.length - 1 ? 0 : current + 1))
    }

    function showPreviousOrangeBanner() {
        setOrangeBannerIndex((current) => (current === 0 ? orangeBannerItems.length - 1 : current - 1))
    }

    function showNextOrangeBanner() {
        setOrangeBannerIndex((current) => (current === orangeBannerItems.length - 1 ? 0 : current + 1))
    }

    return (
        <>
            <section className="relative flex min-h-screen flex-col overflow-hidden bg-white 1.5md:overflow-visible">
                <div
                    className="absolute inset-0 hidden bg-no-repeat sm:block sm:bg-[length:1180px_480px] sm:bg-top 1.5md:bg-[length:1560px_620px] 1.5md:bg-top xl:bg-[length:1760px_700px] xl:bg-top 1.5xl:bg-[length:1915px_750px] 1.5xl:bg-top"
                    style={{ backgroundImage: "url(" + Background + ")" }}
                />
                <MobileHeroDiagonal className="top-[11.25rem] h-[16.5rem] w-[12.6rem] sm:top-[5rem]" />
                <div class="w-full h-1.5 bg-bg_secondary" />

                <div className="relative z-20 mx-auto max-w-8xl container px-5 py-5 sm:px-4 sm:py-7 1.5md:py-9 1.5xl:py-11">
                    <NavigationBar
                        content={content}
                        desktopNavBreakpoint="1.5xl"
                        logoClassName="h-18 sm:h-20 1.5md:h-22 1.5xl:h-25"
                        b2bButtonClassName="px-4 py-[0.45rem] text-[13px] 1.5md:px-4 1.5md:py-[0.45rem] 1.5md:text-[14px] 1.5xl:px-5 1.5xl:py-2 1.5xl:text-lg"
                        hamburgerIconClassName="h-9 w-9 sm:h-10 sm:w-10 1.5md:h-11 1.5md:w-11"
                    />
                </div>

                <section className='relative z-10 flex flex-1 flex-col items-center justify-center overflow-hidden px-4 pb-8 pt-3 md:pb-10 md:pt-4 1.5md:overflow-visible 1.5md:pb-12 1.5md:pt-8 xl:pb-14 xl:pt-10 dark:bg-indigo-950'>
                    <div className='max-w-8xl w-full'>
                        <Carousel slides={main}/>
                    </div>
                </section>
            </section>


            <section className='flex flex-col items-center justify-center bg-bg_secondary max-h-full dark:bg-indigo-950'>
                <div className='container max-w-8xl px-0 py-0 md:hidden'>
                    {currentBlueBannerItem ? (
                        <div className='flex items-center gap-3 px-4 py-5'>
                            <button type="button" onClick={showPreviousBlueBanner} className='flex h-12 w-12 items-center justify-center text-[3rem] leading-none text-white'>
                                &#8249;
                            </button>
                            <div className='flex min-w-0 flex-1 items-center gap-3'>
                                <img
                                    className='h-11 w-11 shrink-0 object-contain'
                                    src={currentBlueBannerItem.image}
                                    alt=''
                                />
                                <div>
                                    <h2 className='text-start text-[18px] font-bold text-text_quaternary'>
                                        {currentBlueBannerItem.title}
                                    </h2>
                                    <p className='mt-1 text-start text-[14px] leading-5 text-white'>
                                        {currentBlueBannerItem.description}
                                    </p>
                                </div>
                            </div>
                            <button type="button" onClick={showNextBlueBanner} className='flex h-12 w-12 items-center justify-center text-[3rem] leading-none text-white'>
                                &#8250;
                            </button>
                        </div>
                    ) : null}
                </div>

                <div className='hidden max-w-8xl px-4 py-8 1.5xl:grid 1.5xl:grid-cols-3 1.5xl:gap-8'>
                    {blueBannerItems?.map((blueBannerItem) =>
                        <AnimatedComponent
                            key={`${blueBannerItem.title}-desktop`}
                            direction={`animate-fade-up animate-duration-500`}
                            className='min-h-fit flex flex-row'
                        >
                            <div className='me-3 flex w-fit flex-col justify-center'>
                                <img
                                    className='h-30 w-30 object-contain'
                                    src={blueBannerItem.image}
                                    alt=''
                                >
                                </img>
                            </div>
                            <div className='flex flex-col justify-center'>
                                <h2 className='text-start text-lg font-bold text-text_quaternary'>
                                    {blueBannerItem.title}
                                </h2>
                                <p className='text-start text-lg text-white'>
                                    {blueBannerItem.description}
                                </p>
                            </div>
                        </AnimatedComponent>
                    )}
                </div>

                <div className='container hidden max-w-8xl px-4 py-7 md:grid md:grid-cols-2 md:gap-8 xl:gap-14 1.5xl:hidden'>
                    {compactBlueBannerItems?.map((blueBannerItem) =>
                        <AnimatedComponent
                            key={blueBannerItem.title}
                            direction={`animate-fade-up animate-duration-500`}
                            className={`min-h-fit flex flex-row items-center`} >
                            <div className='me-4 flex w-fit flex-col justify-center'>
                                <img
                                    className='object-contain h-12 w-12 xl:h-14 xl:w-14'
                                    src={blueBannerItem.image}
                                    alt=''
                                >
                                </img>
                            </div>
                            <div className='flex flex-col justify-center'>
                                <h2 className='text-start font-bold text-text_quaternary text-[17px] xl:text-[18px]'>
                                    {blueBannerItem.title}
                                </h2>
                                <p className='mt-1 text-start text-[14px] leading-6 text-white xl:text-[15px]'>
                                    {blueBannerItem.description}
                                </p>
                            </div>
                        </AnimatedComponent>            
                    )}
                </div>
            </section>

            <section className='pt-14 pb-12 flex flex-col items-center justify-center bg-white max-h-full md:pt-20 xl:pt-24 1.5xl:pt-32 dark:bg-indigo-950'>
                <div className='max-w-8xl w-full px-4 items-center flex flex-col'>
                    <img
                        className='object-contain max-h-[11rem] md:max-h-[15rem] xl:max-h-[16rem] 1.5xl:max-h-80'
                        src='/images/want_to_be_seller.png'
                        alt=''
                    >
                    </img>
                    <div className='w-full flex flex-col my-8 text-center md:my-10 1.5xl:my-15'>
                        <h1 className='font-bold text-text_primary text-[23px] md:text-[32px] xl:text-[36px] 1.5xl:text-4xl'>
                            {section2.title}
                        </h1>
                        <p className='mx-auto max-w-[17rem] pt-3 text-[14px] leading-6 text-text_secondary md:max-w-[42rem] md:text-[15px] md:leading-7 xl:max-w-[48rem] xl:text-[16px] 1.5xl:max-w-[44rem] 1.5xl:text-lg'>
                            {section2.description}
                        </p>
                    </div>
                </div>

                <DealershipActionCards
                    className='mx-auto max-w-fit pt-6 pb-10 md:pt-8 md:pb-12 lg:grid-cols-3 lg:gap-2 1.5xl:px-8 1.5xl:pt-15 1.5xl:pb-15'
                    itemClassName='flex justify-center'
                    imageClassName='w-full max-w-[18rem] object-contain transition-transform duration-300 hover:scale-105 md:max-w-[15rem] xl:max-w-[18rem] 1.5xl:max-h-74 1.5xl:max-w-none'
                />
            </section>

            <section className='pt-14 pb-18 flex flex-col items-center justify-center bg-bg_tertiary max-h-full md:pt-16 md:pb-20 xl:pt-18 xl:pb-22 dark:bg-indigo-950'>
                <div className='max-w-8xl w-full px-4 items-center flex flex-col 1.5xl:hidden'>
                    <div className='w-full flex flex-col text-center'>
                        <h1 className='font-bold text-text_primary text-[23px] md:text-[30px] xl:text-[36px]'>
                            {section3.title}
                        </h1>
                    </div>

                    <div className='mt-8 flex justify-center md:mt-10'>
                        <img
                            className='object-contain max-h-[15rem] md:max-h-[18rem] xl:max-h-[19rem]'
                            src='/images/why_us.svg'
                            alt=''
                        >
                        </img>
                    </div>

                    <div className='mt-8 grid w-full gap-x-12 gap-y-6 md:mt-10 md:grid-cols-2 xl:max-w-[70rem] xl:gap-x-16 xl:gap-y-8'>
                        {whyBulutmarketItems?.map((whyBulutmarketItem) =>
                            <div key={whyBulutmarketItem.title}>
                                <h2 className='font-bold text-text_primary text-[17px] md:text-[16px] xl:text-[17px]'>
                                    {whyBulutmarketItem.title}
                                </h2>
                                <p className='mt-2 text-[14px] leading-6 text-text_secondary md:text-[14px] xl:text-[15px] xl:leading-7'>
                                    {whyBulutmarketItem.description}
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                <div className='hidden max-w-8xl w-full 1.5xl:flex 1.5xl:flex-col 1.5xl:px-4'>
                    <div className='w-full flex flex-col text-center'>
                        <h1 className='font-bold text-text_primary text-4xl'>
                            {section3.title}
                        </h1>
                    </div>

                    <div className='grid w-full grid-cols-3 gap-4 pt-23 pb-4'>
                        <div className='flex w-full flex-col justify-center pt-10'>
                            <img
                                className='inline-flex max-h-112 object-contain'
                                src='/images/why_us.svg'
                                alt=''
                            >
                            </img>
                        </div>
                        <div className='col-span-2 grid grid-cols-2 justify-start gap-6 ps-20 pe-6'>
                            {whyBulutmarketItems?.map((whyBulutmarketItem) =>
                                <div key={`${whyBulutmarketItem.title}-desktop`} className='[&:nth-child(odd)]:pe-7 [&:nth-child(even)]:ps-6'>
                                    <h2 className='text-lg font-bold text-text_primary'>
                                        {whyBulutmarketItem.title}
                                    </h2>
                                    <p className='text-lg text-text_secondary'>
                                        {whyBulutmarketItem.description}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <section className='flex flex-col items-center justify-center text-center bg-bg_primary max-h-full dark:bg-indigo-950'>
                <div className='container max-w-8xl px-0 py-0 md:hidden'>
                    {currentOrangeBannerItem ? (
                        <div className='flex items-center gap-3 px-4 py-4 text-white'>
                            <button type="button" onClick={showPreviousOrangeBanner} className='flex h-12 w-12 items-center justify-center text-[3rem] leading-none'>
                                &#8249;
                            </button>
                            <div className='flex-1 text-left'>
                                <h2 className='text-[17px] font-bold'>
                                    {currentOrangeBannerItem.title}
                                </h2>
                                <p className='mt-1 text-[14px] leading-6'>
                                    {currentOrangeBannerItem.description}
                                </p>
                            </div>
                            <button type="button" onClick={showNextOrangeBanner} className='flex h-12 w-12 items-center justify-center text-[3rem] leading-none'>
                                &#8250;
                            </button>
                        </div>
                    ) : null}
                </div>

                <div className='hidden max-w-8xl px-4 py-8 md:grid md:grid-cols-3 md:divide-x md:divide-white xl:py-10 1.5xl:px-4 1.5xl:pt-8 1.5xl:pb-13'>
                {orangeBannerItems?.map((orangeBannerItem, index) =>
                     <AnimatedComponent
                     key={orangeBannerItem.title}
                     direction={`animate-fade-up animate-duration-500`}
                     className={`min-h-fit flex flex-col justify-start px-8 py-8 xl:px-10 xl:py-9 1.5xl:px-12 1.5xl:py-9`} >
                        <div className='flex flex-col justify-start'>
                            <h2 className='pb-2 font-bold text-white text-[24px] xl:text-[28px] 1.5xl:text-3xl'>
                                {orangeBannerItem.title}
                            </h2>
                            <p className='text-[14px] leading-6 text-white xl:text-[15px] xl:leading-7 1.5xl:text-lg'>
                                {orangeBannerItem.description}
                            </p>
                        </div>
                    </AnimatedComponent>
                )}
                </div>
            </section>

            <section className='pt-14 flex flex-col items-center justify-center bg-white max-h-full md:pt-18 xl:pt-22 dark:bg-indigo-950'>
                <div className='max-w-8xl w-full pb-8 px-4 items-center flex flex-col'>
                    <div className='w-full flex flex-col text-center'>
                        <h1 className='font-bold text-text_primary text-[23px] md:text-[30px] xl:text-[36px]'>
                            {section4.title1}
                        </h1>
                    </div>
                </div>

                <ProductRange/>
            </section>

            <section className='pb-24 pt-8 flex flex-col items-center justify-center bg-white max-h-full md:pb-28 xl:pb-32 dark:bg-indigo-950'>
                <div className='max-w-8xl w-full px-4 py-8 items-center flex flex-col'>
                    <div className='w-full flex flex-col text-center'>
                        <h1 className='font-bold text-text_primary text-[23px] md:text-[30px] xl:text-[36px]'>
                            {section4.title2}
                        </h1>
                    </div>
                </div>

                <Brands/>
            </section>
        </>
    );
}
